import api from './api'
import CallHelper from '@/helpers/call.helper'

class referenceIndexService {
    async get(params = {}) {
        return CallHelper.getDataRecursive('/reference-index', params, (data, response) => {
            if(data.length) {
                data = [...data, ...response.data.reference_index]
            } else {
                data = response.data.reference_index
            }

            return data
        },)
    }

    async getInstance(uuid) {
        return api.get('/reference-index/' + uuid)
    }

    async getToUpdate(params = {}) {
        return api.get('/reference-index/to-update', params)
    }
}

export default new referenceIndexService()
